"use client";

import { createContext, useEffect, useState, ReactNode } from "react";
import { usePathname } from "next/navigation";

interface AnalyticsContextProps {
  visitedPages: string[];
  setVisitedPages: React.Dispatch<React.SetStateAction<string[]>>;
}

export const AnalyticsContext = createContext<AnalyticsContextProps>({
  visitedPages: [],
  setVisitedPages: () => {},
});

interface AnalyticsProviderAppProps {
  children: ReactNode;
}

export default function AnalyticsProviderApp({
  children,
}: AnalyticsProviderAppProps) {
  const pathname = usePathname();
  const [visitedPages, setVisitedPages] = useState<string[]>([]);

  useEffect(() => {
    if (!pathname) return;
    // Pathname is router-driven external state, not derived from render state.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setVisitedPages((prev) => [...prev, pathname]);
  }, [pathname]);

  return (
    <AnalyticsContext.Provider value={{ visitedPages, setVisitedPages }}>
      {children}
    </AnalyticsContext.Provider>
  );
}
